<div _ngcontent-ng-c875931659="" class="col-md-12 footerDiv mobile-android-height">
<div _ngcontent-ng-c875931659="" class="inner-footer">
<!-- -->
<div _ngcontent-ng-c875931659="" class="support-wrap">
<dl _ngcontent-ng-c875931659="" class="support-mail">
<a _ngcontent-ng-c875931659="" class="rules-btn-home" data-bs-target="#exampleModal" data-bs-toggle="modal">Privacy Policy</a><a _ngcontent-ng-c875931659="" class="rules-btn-home arrow" data-bs-target="#exampleModal" data-bs-toggle="modal">KYC</a><a _ngcontent-ng-c875931659="" class="rules-btn-home arrow" data-bs-target="#exampleModal" data-bs-toggle="modal">Terms and Conditions</a><a _ngcontent-ng-c875931659="" class="rules-btn-home arrow" data-bs-target="#exampleModal" data-bs-toggle="modal">Rules and Regulations</a><a _ngcontent-ng-c875931659="" class="rules-btn-home arrow" data-bs-target="#exampleModal" data-bs-toggle="modal">Responsible Gambling</a>
</dl>
<!-- --><!-- -->
</div>
<div _ngcontent-ng-c875931659="" class="extra-wrap">
<div _ngcontent-ng-c875931659="" class="appdl-link-android" style="display: block">
<a _ngcontent-ng-c875931659="" target="_blank"><img _ngcontent-ng-c875931659="" alt="" src="./../../../assets/androidapk.png"/></a><!-- --><!-- -->
</div>
</div>
</div>
</div>
<div _ngcontent-ng-c875931659="" aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="exampleModal" role="dialog" tabindex="-1">
<div _ngcontent-ng-c875931659="" class="modal-dialog modal-md" role="document">
<div _ngcontent-ng-c875931659="" class="modal-content">
<div _ngcontent-ng-c875931659="" class="modal-content rules-wrap">
<div _ngcontent-ng-c875931659="" class="rules-content">
<div _ngcontent-ng-c875931659=""></div>
</div>
<ul _ngcontent-ng-c875931659="" class="btn-wrap break">
<li _ngcontent-ng-c875931659="">
<a _ngcontent-ng-c875931659="" class="btnok" data-bs-dismiss="modal">OK</a>
</li>
</ul>
</div>
</div>
</div>
</div>